export const environment = {
  production: false,
  apiBaseUrl: 'https://estimator.voidcon.com/php/api/'
};

